import { useEffect } from 'react';

import useAbdmModeStore, { ABDM_MODE_DISABLED } from '../stores/abdmModeStore';

/**
 * useAbdmEnabled - single source of truth for "show ABDM/ABHA UI". Returns { ready, enabled, show }:
 * `show` is true only once the mode is known and is not DISABLED, so nothing ABDM-specific flashes
 * while loading. Fetches once per session (the store shares the in-flight request).
 */
export default function useAbdmEnabled() {
  const mode = useAbdmModeStore((s) => s.mode);
  const ready = useAbdmModeStore((s) => s.ready);
  const signedOut = useAbdmModeStore((s) => s.signedOut);
  const fetchMode = useAbdmModeStore((s) => s.fetchMode);
  const unblock = useAbdmModeStore((s) => s.unblock);

  useEffect(() => { unblock(); }, [unblock]); // mount only: a new screen = a new session may start

  useEffect(() => {
    if (!ready && !signedOut) fetchMode();
  }, [ready, signedOut, fetchMode]);

  const enabled = mode !== ABDM_MODE_DISABLED;
  return { ready, enabled, show: ready && enabled };
}
